/**
* Local Imports
*/

import { Button } from './Button';
import { Buttons } from './Buttons';
import { Submit } from './Submit';
import { ValuedField } from './ValuedField';
import { HiddenField } from './HiddenField';
import { LabeledField } from './LabeledField';
import { Input } from './Input';
import { Select } from './Select';
import { Checkbox } from './Checkbox';
import { Radio } from './Radio';

/**
 * Exports
*/

export {
  Button,
  Buttons,
  Submit,
  ValuedField,
  HiddenField,
  LabeledField,
  Input,
  Select,
  Checkbox,
  Radio
}

/**
 * 
 */
export function CheckFormik(formik) {
  return {
    isFormik: !!formik,
    isFormikSubmitting: (!!formik && formik.isSubmitting)
  };
}